






















import { Component, Watch, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { CaseDashboard, Tab } from "@/store/modules/types";
import Pager from "@/components/case/Pager.vue";
import List from "@/components/case/List.vue";
import LogViewer from "./edit/LogViewer.vue";
import { randomId } from "@/utils";

@Component({
  components: {
    Pager,
    List,
    LogViewer,
  },
  computed: {
    ...mapState("cases", ["dashboard"]),
  },
})
export default class Dashboard extends Vue {
  dashboard!: CaseDashboard;
  selected: any | null = null;
  @Watch("dashboard.filter", { deep: true })
  onFilterChanged() {
    this.getCases();
  }
  async getCases() {
    this.$store.commit("main/SET_LOADING", true);
    try {
      await this.$store.dispatch("cases/getList");
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async getCasesCSV() {
    this.$store.commit("main/SET_LOADING", true);
    try {
      const data = await this.$store.dispatch("cases/getListCSV");
      const blob = new Blob([data], { type: "text/csv" });
      const timestamp = this.$moment().format("YYMMDD_HHmmss");
      const anchor = document.createElement("a");
      anchor.download = `WMPC_CASES_${timestamp}.csv`;
      anchor.href = window.URL.createObjectURL(blob);
      anchor.dataset.downloadurl = [
        "text/csv",
        anchor.download,
        anchor.href,
      ].join(":");
      anchor.click();
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async getCasesExcel() {
    this.$store.commit("main/SET_LOADING", true);
    try {
      const mime = "application/octet-stream";
      const data = await this.$store.dispatch("cases/getListExcel");
      const blob = new Blob([data], { type: mime });
      const timestamp = this.$moment().format("YYMMDD_HHmmss");
      const anchor = document.createElement("a");
      anchor.download = `WMPC_CASES_${timestamp}.xlsx`;
      anchor.href = window.URL.createObjectURL(blob);
      anchor.dataset.downloadurl = [mime, anchor.download, anchor.href].join(
        ":"
      );
      anchor.click();
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async getCarePlanExcel() {
    this.$store.commit("main/SET_LOADING", true);
    try {
      const mime = "application/octet-stream";
      const data = await this.$store.dispatch("cases/getCarePlanExcel");
      const blob = new Blob([data], { type: mime });
      const timestamp = this.$moment().format("YYMMDD_HHmmss");
      const anchor = document.createElement("a");
      anchor.download = `WMPC_CARE_PLANS_${timestamp}.xlsx`;
      anchor.href = window.URL.createObjectURL(blob);
      anchor.dataset.downloadurl = [mime, anchor.download, anchor.href].join(
        ":"
      );
      anchor.click();
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async getFormsExcel() {
    this.$store.commit("main/SET_LOADING", true);
    try {
      const mime = "application/octet-stream";
      const data = await this.$store.dispatch("cases/getFormsExcel");
      const blob = new Blob([data], { type: mime });
      const timestamp = this.$moment().format("YYMMDD_HHmmss");
      const anchor = document.createElement("a");
      anchor.download = `WMPC_ASSESSMENTS_${timestamp}.xlsx`;
      anchor.href = window.URL.createObjectURL(blob);
      anchor.dataset.downloadurl = [mime, anchor.download, anchor.href].join(
        ":"
      );
      anchor.click();
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async editCase(item) {
    // GET CASE RECORD
    this.$store.commit("main/SET_LOADING", true);
    try {
      const data = await this.$store.dispatch("cases/getRecord", item.id);
      data.record.patientInfo = {
        demographic: null,
        contacts: [],
        providers: [],
        gaps: [],
      };
      data.record.medicationNotes = [];
      data.record.comments = [];
      // CREATE TAB
      const id = randomId(6);
      const tab: Tab = {
        id,
        name: `Case ${item.id}`,
        component: "CaseEditor",
        props: {
          tabId: id,
          caseRecord: data.record,
        },
        showRemove: true,
      };
      // ADD CASE TAB
      this.$store.commit("cases/ADD_NEW_TAB", tab);
      //
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
    //
  }
  editPatient(id: number) {
    this.$emit("edit-patient", id);
  }
  showLog(item) {
    this.selected = item;
    this.$modal.show("log-viewer");
  }
  checkCases() {
    this.dashboard.pageRows.forEach((item) => {
      item.checked = true;
    });
  }
  uncheckCases() {
    this.dashboard.pageRows.forEach((item) => {
      item.checked = false;
    });
  }
  get checkedRows() {
    return this.dashboard.pageRows.filter((row) => {
      return row.checked;
    });
  }
  get rowsChecked(): Boolean {
    return this.checkedRows.length != 0;
  }
}
